var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-nav',{staticClass:"vertical-nav"},[_c('nav-item',{attrs:{"to":"/profile","text":_vm.$t('userInfoAndSettings.sectionTitle'),"exact":""}},[_c('user-icon',{attrs:{"fillColor":_vm.ICONS_FILL_COLOR}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }